// extracted by mini-css-extract-plugin
export default {"lineButtons":"otherPropertyItemNew_lineButtons__Z42sq","headers":"otherPropertyItemNew_headers__fMRQJ","semiTitle":"otherPropertyItemNew_semiTitle__iunOp"};